import { Pipe, ChangeDetectorRef } from '@angular/core';
import { parse, distanceInWordsToNow } from 'date-fns';
import { AsyncPipe } from '@angular/common';
import { timer, Observable } from 'rxjs';
import { tap, map, distinctUntilChanged, startWith } from 'rxjs/operators';
import {  } from 'date-fns/locale/fr'
const frLocale = require('date-fns/locale/fr') 

@Pipe({
  name: 'timeAgo',
  pure: false,
})
export class TimeAgoPipe extends AsyncPipe {

  private time: Date;
  private formatted$: Observable<string>;

  constructor(private cd: ChangeDetectorRef) {
    super(cd);

    this.formatted$ = timer(0, 1000).pipe(
      map(() => distanceInWordsToNow(this.time, { addSuffix: true, includeSeconds: true, locale: frLocale })),
      distinctUntilChanged()
    );
  }

  public transform(value: any): any {
    this.time = parse(value);
    return super.transform(this.formatted$);
  }

}